import http from '../config/http';
import routes from '../config/api_routes';

export const login = ({user, password,activationCode,grantType="password"}) => {
    console.log('loginService.login');
    return http(true)
        .post(routes.login,
            {
                userID: user,
                accessKey: password,
                grantType,
                activationCode
            }
        )          
}
export const logout = () => http().post(routes.logout)
export const reAuth = token => {
    return http(true)
        .post(routes.login,
            {
                userID: "",
                accessKey: token,
                grantType: 'refresh_token',
            }
        )          
}


